@if (showModal) {
  <div
    class="cookie-modal-wrapper">
    <div [@appearSlowlyAnimation]
      class="bottom-modal">
      <div [ngClass]="isMobile ? 'mobile-css' : 'desktop-css'"
        class="bottom-modal-body white-bg">
        <app-page-content-header
          [title1]="'shared.prescriptionConsentHeader'">
        </app-page-content-header>
        <div id="modal-description" role="dialog">
          <span [innerHtml]="termsText.text | tagConversion"></span>
          <div class="d-flex justify-content-center align-items-center">
            <u><a (click)="expandText = !expandText" class="link-color"
              tabindex="0">
              {{ expandText ? ("shared.readLess" | translate) : "shared.readMore" | translate }}
            </a></u>
          </div>
          <!-- More expanded text -->
          @if (expandText) {
            <div [innerHTML]="'shared.whyWeNeedConsentText' | translate" appLinkHandler class=" mt-5"></div>
          }
        </div>
        @if ((!previousCheckboxState) || (previousCheckboxState && !sessionContext.termsOutput.prescriptionsAccepted)) {
          <ng-container>
            @if (isUrlFetching) {
              <button
                class="btn btn-primary button-width my-4"
                [disabled]="isUrlFetching">
                @if (isUrlFetching) {
                  <span class="loading-animation-container">{{'shared.consentCheck' | translate }}
                    <div class="loading-dots" [ngClass]="{'narrow-loading-dots' : !isMobile}"></div></span>
                  }
                </button>
              }
            </ng-container>
            @if (!isUrlFetching && receivedURL) {
              <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}"
                class="bottom-modal-btn-container my-4">
                <button (click)="onAccept(true)" class="btn btn-primary mt-2" style=" margin: 0; min-width: 12rem;">
                  {{ 'shared.giveConsent'| translate }}
                </button>
                <button (click)="onClose()"
                  class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2">{{ 'shared.back' | translate | uppercase }}
                </button>
              </div>
            }
            @if (!isUrlFetching && !receivedURL) {
              <div [ngStyle]="{ 'font-size': isMobile ? 'small' : '' }" class="text-center mt-4">
                {{ "shared.prescriptionNtCheckText" | translate }}
              </div>
              <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}"
                class="bottom-modal-btn-container my-4">
                <button (click)="onAccept(false)" class="btn btn-primary mt-2"
                  style=" margin: 0; min-width: 12rem;">{{ 'shared.confirm'| translate }}
                </button>
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
